import styled, {css} from "styled-components"

const HelpCard = styled.div`
  ${({theme}) => css`
    background: ${theme.colors.utility.highlight};
    border-radius: 0 0 ${theme.spacing.one} ${theme.spacing.one};

    padding: ${theme.spacing.three};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.four} ${theme.spacing.five};
    `}
  `}
`

export default HelpCard
